/* eslint-disable max-lines */
/* eslint-disable react/jsx-max-depth */
/* eslint-disable max-lines */
import PropTypes from 'prop-types';
import queryString from 'querystring';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ButtonLink from '../../components/elements/ButtonLink';
import DataTable from '../../components/elements/DataTable';
import Text from '../../components/fields/Text';
import { useDebounce } from '../../utils/hooks';
import styles from './styles.scoped.css';
// import { formatDateTime } from '../../utils/format';
import Card from '../../components/elements/Card';
import ErrorHandler from '../../components/elements/ErrorHandler';
import { AppContext } from '../../contexts';
// import { processColor, processStatus } from './constants';
// import Tag from '../../components/elements/Tag';
// import classNames from '../../utils/classNames';
import moment from 'moment';
import { ModalDownloadOutOfRange } from '../../components/elements/ModalDownload';
import ScrollToTop from '../../components/elements/ScrollToTop';
import Tab from '../../components/elements/Tab';
import RegistrationFilter from '../../components/fragments/RegistrationFilter/RegistrationFilter';
import { thousand } from '../../utils/format';
import FailedMerchantRegistration from './FailedMerchantRegistration';
import {
  fetchFailedMerchantRegistrations,
  fetchMerchantRegistrations,
} from './actions';

export default function RegistrasiMerchant({ category }) {
  const { setBreadcrumbs } = useContext(AppContext);
  const ref = useRef(true);
  const inputRef = useRef(null);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  // const userRegion = getRegional();
  // const adminId = getAdminId();

  const [search, setSearch] = useState('');
  const [fromDate, setFromDate] = useState(
    moment().subtract(6, 'day').toDate()
  );
  const [toDate, seToDate] = useState(moment().toDate());
  const [page, setPage] = useState(1);
  const [modalOutRangeVisible, setModalOutRangeVisible] = useState(false);
  const [tabItem, setTabItem] = useState('success');

  const {
    dataMerchantRegistrations: { data, meta },
    dataFailedMerchantRegistrations,
    // dataDownloadRegistrationReport: { generating = false, link = null },
    isLoadingMerchantRegistrations,
    messageMerchantRegistrations,
    dataFilter,
    // isLoadingDownloadRegistrationReport,
  } = useSelector((s) => s.merchantRegistrations);

  const { dataDetailUser } = useSelector((state) => state.pageBase);

  const {
    regional = dataDetailUser?.regionalId
      ? JSON.stringify([dataDetailUser?.regionalId])
      : '',
    provinceId = dataDetailUser?.provinceId,
    cityId = dataDetailUser?.cities,
    districtId = dataFilter.districtId ?? '',
    villageId = '',
    registrationStatus = 'all',
    outletType = '',
    wave = '',
    agenId = '',
    samId = dataDetailUser?.sam?.id
      ? JSON.stringify([dataDetailUser?.sam?.id])
      : '',
    sbmId = dataDetailUser?.sbm?.id
      ? JSON.stringify([dataDetailUser?.sbm?.id])
      : '',
    startDate = '',
    endDate = '',
  } = queryString.parse(location.search.replace('?', ''));

  // const {
  //   dataDetailUser
  // } = useSelector((s) => s.pageBase);

  useEffect(() => {
    setBreadcrumbs(['Registrasi Pangkalan LPG 3 Kg']);
  }, []);

  const debounceParams = useDebounce(
    category +
      regional +
      provinceId +
      cityId +
      districtId +
      villageId +
      registrationStatus +
      search +
      outletType +
      wave +
      agenId +
      samId +
      sbmId +
      startDate +
      endDate,
    500
  );

  function getAllParams(page) {
    let allParams = {
      regional: regional === 'All' ? '' : regional,
      provinceId: provinceId === 'All' ? '' : provinceId,
      cityId: cityId,
      districtId: districtId === 'All' ? '' : districtId,
      villageId: villageId === 'All' ? '' : villageId,
      search,
      page: page ? page : 1,
      startDate: moment(fromDate).format('YYYY-MM-DD'),
      endDate: moment(toDate).format('YYYY-MM-DD'),
      wave: wave,
      agenId: agenId,
      samId: samId,
      sbmId: sbmId,
    };

    if (outletType) {
      allParams.outletType = outletType;
    }
    if (registrationStatus !== 'all') {
      allParams.registrationStatus = registrationStatus;
    }
    return allParams;
  }

  const fetchRegistrationList = () => {
    dispatch(fetchMerchantRegistrations(getAllParams()));
  };

  useEffect(() => {
    if (page > 1) {
      dispatch(fetchMerchantRegistrations(getAllParams(page)));
    }
  }, [page]);

  useEffect(() => {
    setFromDate(
      dataFilter?.registrationDate?.length > 1
        ? dataFilter.registrationDate[0]
        : fromDate
    );
    seToDate(
      dataFilter?.registrationDate?.length > 1
        ? dataFilter.registrationDate[1]
        : toDate
    );
  }, [dataFilter]);

  useEffect(() => {
    navigate('?');
  }, [tabItem]);

  useEffect(() => {
    if (!isLoadingMerchantRegistrations && data.length <= 100) {
      inputRef.current?.focus();
    }
  }, [isLoadingMerchantRegistrations]);

  useEffect(() => {
    setPage(1);
    fetchRegistrationList();
    if (ref.current) {
      dispatch(fetchFailedMerchantRegistrations(getAllParams()));
      ref.current = false;
    }
  }, [debounceParams]);

  useEffect(() => {
    const getData = setTimeout(() => {
      dispatch(fetchFailedMerchantRegistrations(getAllParams()));
    }, 2000);
    return () => clearTimeout(getData);
  }, [search]);

  const renderdetail = (id, index) => {
    const handleColoringRow = () => {
      if ((index + 1) % 2 === 0) {
        return 'actionBlue';
      } else {
        return 'actionWhite';
      }
    };
    return (
      <div className={handleColoringRow()}>
        <Link
          className={styles['detail-btn']}
          to={'/merchant/registrasi-pangkalan/' + id + '/success'}
          type="primary"
        >
          Detail
        </Link>
      </div>
    );
  };

  const column = [
    { heading: 'Tanggal Registrasi', value: 'registrationDate' },
    { heading: 'Jam', value: 'registrationTime' },
    { heading: 'ID Registrasi', value: 'registrationId' },
    { heading: 'MID', value: 'midMap' },
    { heading: 'Nama Pangkalan LPG 3 Kg', value: 'storeName' },
    { heading: 'Nama Pemilik', value: 'ownerName' },
    { heading: 'No. Ponsel', value: 'phoneNumber' },
    { heading: 'Email', value: 'email' },
    { heading: 'Petinjau', value: 'reviewer' },
    {
      heading: 'Action',
      value: ({ userId }, index) => renderdetail(userId, index),
      className: '',
    },
  ];

  if (messageMerchantRegistrations) {
    return <ErrorHandler message={messageMerchantRegistrations} />;
  }

  const tabList = [
    { label: 'Berhasil', value: 'success', info: '' },
    {
      label: 'Gagal',
      value: 'failed',
      info: dataFailedMerchantRegistrations.meta.totalData,
    },
  ];

  const handleChangeTab = (val) => {
    setTabItem(val);
  };

  return (
    <div className={styles.mainRoot}>
      <Tab data={tabList} defaultValue={tabItem} onChange={handleChangeTab} />
      <br />
      {tabItem === 'success' ? (
        <>
          <RegistrationFilter />
          <Card className={styles['table-filter-container']}>
            {dataDetailUser?.userType === 'superadmin' && (
              <ButtonLink
                className={styles['upload-regist-btn']}
                disabled={true}
                to={location.pathname + '/' + 'registrasi-sekaligus'}
                type="primary"
              >
                <img src="assets/ic-upload.svg" />
                Upload Data
              </ButtonLink>
            )}
            <span>
              Menampilkan <strong>{thousand(meta.totalData)}</strong> data
            </span>
            <div className={styles['filter-wrap']}>
              <div className={styles.filters}>
                <Text
                  className={styles['search-bar']}
                  disabled={isLoadingMerchantRegistrations}
                  hideLabel
                  inputProps={{
                    ref: inputRef,
                    placeholder: 'Cari data...',
                    value: search,
                    icon: 'ic-search.svg',
                    onChange: (e) => setSearch(e.target.value),
                  }}
                />
              </div>
            </div>
          </Card>
          <br />
          <div className={styles['table-container']}>
            <DataTable
              className={styles.table}
              column={column}
              data={data}
              endTreshould={200}
              loading={isLoadingMerchantRegistrations}
              meta={meta}
              onEndReached={() => setPage(page + 1)}
              onRefresh={fetchRegistrationList}
              withIndex
            />
          </div>
          <ModalDownloadOutOfRange
            onClose={() => setModalOutRangeVisible(false)}
            open={modalOutRangeVisible}
          />
        </>
      ) : (
        <FailedMerchantRegistration />
      )}
      <ScrollToTop />
    </div>
  );
}

RegistrasiMerchant.propTypes = {
  category: PropTypes.shape({
    categoryId: PropTypes.string,
    unit_name: PropTypes.string,
    unit_symbol: PropTypes.string,
  }),
};
